import OrderFileUploader from "./orderFileUploader";

export const OrderUploadHandlerModal = ({companyId, orderId}) => {


    const settings = [
        {
            name: "Dokumente und Plandaten (z.B. Urkunde, Begründung, Leistungsverzeichnis, Vektordaten, ALKIS, usw.)",
            path: companyId+"/orders/"+orderId.replaceAll("-", '/')+"/documents"
        }
    ];

    return (
        <div>
            <h4 className={"text-xl font-bold"}>Bestandsunterlagen hochladen</h4>
            <p className={"text-sm leading-6 text-gray-600/60   my-4"}>Falls bereits Unterlagen wie Altpläne im PDF Format, Shape- oder CAD-Dateien vorliegen, können Sie diese gerne direkt in Ihrem Auftrag hinterlegen.</p>


            {settings?.map((setting, index) => (
                <div className={"mb-8"} key={index}>
                    {OrderFileUploader(setting?.name,setting?.path,true, 'Dokumente und Plandaten', '', true, orderId, companyId, "documents")}
                </div>
            ))}
        </div>

    );
};
